import apiClient from './api';
import { API_CONFIG } from '../utils/constants';
import { PagoCliente } from '../models/PagoCliente';

export class PagoClienteService {
  
  // Obtener todos los productos con soporte de imágenes
  static async getAllPa(id, incluirImagen = true) {
    try {
      console.log('🔍 === GETALLPAGOCLIENTE DEBUG ===');
      console.log('🔍 URL:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.PAGOCLIENTE);
      console.log('🔍 Sucursal ID:', id);
      console.log('🔍 Incluir imagen:', incluirImagen);
      
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.PAGOCLIENTE}/sucursal/${id}?incluirImagen=${incluirImagen}`
      );
      
      console.log('✅ Respuesta cruda del API:', response.data);
      console.log('✅ Tipo de response.data:', typeof response.data);
      console.log('✅ Keys de response.data:', Object.keys(response.data));
      
      // Manejo específico para el formato de API
      let Data;
      if (response.data.success && response.data.data) {
        Data = response.data.data; // Formato: {success: true, data: [...]}
        console.log('✅ Usando response.data.data (formato success/data)');
      } else if (Array.isArray(response.data)) {
        Data = response.data; // Formato directo: [...]
        console.log('✅ Usando response.data (formato array directo)');
      } else {
        console.error('❌ Formato de API no reconocido:', response.data);
        throw new Error('Formato de datos incorrecto del servidor');
      }
      
      console.log('✅ Datos extraídos:', Data);
      console.log('✅ Es array?', Array.isArray(Data));
      console.log('✅ Cantidad de elementos:', Data.length);
      
      if (!Array.isArray(Data)) {
        console.error('❌ Data no es array:', Data);
        throw new Error('Los datos recibidos no son un array');
      }
      
      // Mapear cada producto y mostrar debug
      const mapped = Data.map((productData, index) => {
        console.log(`🔍 Mapeando PagoCLiente ${index}:`, productData);
        
        // Crear instancia de Productos
        const datos = new PagoCliente(productData);
        
        console.log(`✅ PagoCLiente mapeado ${index}:`, datos.toDebug());
        
        // Debug específico para imagen
        if (datos.Imagen) {
          console.log(`🖼️ PagoCLiente ${index} tiene imagen de ${datos.Imagen.length} caracteres`);
        } else {
          console.log(`🖼️ PagoCLiente ${index} no tiene imagen`);
        }
        
        return datos;
      });
      
      console.log('✅ TODOS LOS PagoCLiente MAPEADOS:', mapped.length);
      return mapped;
      
    } catch (error) {
      console.error('❌ === ERROR GETALLPagoCLiente ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response:', error.response);
      console.error('❌ Error message:', error.message);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Status Text:', error.response.statusText);
        console.error('❌ Data:', error.response.data);
        console.error('❌ Headers:', error.response.headers);
      }
      
      throw new Error('Error al obtener PagoCLiente: ' + error.message);
    }
  }

  // Obtener producto por ID
  static async getById(id, incluirImagen = true) {
    try {
      console.log('🔍 Obteniendo PagoCLiente ID:', id);
      const response = await apiClient.get(
        `${API_CONFIG.ENDPOINTS.PAGOCLIENTE}/${id}?incluirImagen=${incluirImagen}`
      );
      console.log('✅ PagoCLiente obtenido:', response.data);
      
      const productData = response.data.data || response.data;
      return new PagoCliente(productData);
    } catch (error) {
      console.error('❌ Error obteniendo PagoCLiente:', error);
      throw new Error('Error al obtener el PagoCLiente');
    }
  }

  // 🔧 CREAR PRODUCTO - MÉTODO CORREGIDO
  static async create(Data) {
    try {
      console.log('🔍 === CREATE PagoCLiente DEBUG ===');
      console.log('🔍 Data recibido:', Data);
      
      let datos;
      if (Data instanceof PagoCliente) {
        datos = Data;
      } else {
        datos = new PagoCliente(Data);
      }
      
      console.log('🔍 PagoCLiente instance:', datos.toDebug());
      
      // ✅ USAR FORMDATA PARA CREAR PRODUCTOS
      const formData = new FormData();
      
      // Campos básicos (SIN incluir id_producto para crear)
     
      formData.append('descripcion', datos.Descripcion || '');      
      formData.append('estado', datos.Estado || 'ACTIVO');      
      formData.append('id_sucursal', parseInt(datos.Id_sucursal) || 0);
      
      // ✅ MANEJAR LA IMAGEN CORRECTAMENTE - SOLO imagenFile
      if (datos.Imagen && datos.Imagen.length > 0) {
        console.log('🖼️ Creando PagoCLiente con imagen - tamaño base64:', datos.Imagen.length);
        
        try {
          // Convertir base64 a Blob
          const base64Data = datos.Imagen.replace(/^data:image\/[^;]+;base64,/, '');
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });
          
          // ✅ ENVIAR SOLO COMO imagenFile - NO enviar campo 'imagen'
          formData.append('imagenFile', blob, 'PagoCLiente.jpg');
          console.log('✅ Imagen agregada al FormData SOLO como imagenFile');
          
        } catch (imageError) {
          console.error('❌ Error procesando imagen para creación:', imageError);
          throw new Error('Error al procesar la imagen');
        }
      } else {
        console.log('📝 Creando PagoCLiente sin imagen');
      }
      
      // Debug del FormData final
      console.log('🔍 === FormData FINAL para CREATE ===');
      for (let pair of formData.entries()) {
        const value = pair[1] instanceof Blob ? `[BLOB: ${pair[1].size} bytes]` : pair[1];
        console.log(`  ${pair[0]}: ${value}`);
      }
      
      const response = await apiClient.post(
        API_CONFIG.ENDPOINTS.PAGOCLIENTE,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      
      console.log('✅ PagoCLiente creado exitosamente:', response.data);
      
      const createdData = response.data.data || response.data;
      return new PagoCliente(createdData);
      
    } catch (error) {
      console.error('❌ === ERROR CREANDO PagoCLiente ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response data:', error.response?.data);
      console.error('❌ Error status:', error.response?.status);
      throw new Error('Error al crear el PagoCLiente: ' + (error.response?.data?.message || error.message));
    }
  }

  // 🔧 ACTUALIZAR PRODUCTO - MÉTODO CORREGIDO
  static async update(id, Data) {
    try {
      console.log('🔍 === UPDATE PagoCLiente DEBUG ===');
      console.log('🔍 URL ID:', id);
      
      if (!id) {
        throw new Error('ID de PagoCLiente no proporcionado');
      }
      
      let datos;
      if (Data instanceof PagoCliente) {
        datos = Data;
      } else {
        datos = new PagoCliente(Data);
      }
      
      console.log('🔍 PagoCLiente.Id_pagoc:', datos.Id_pagoc);
      console.log('🔍 PagoCLiente a actualizar:', datos.toDebug());
      
      // ✅ USAR FORMDATA PARA ACTUALIZAR PagoCLiente
      const formData = new FormData();
      
      // ✅ INCLUIR ID EN FORMDATA - EL API LO VALIDA CONTRA LA URL
      // Campos básicos (incluyendo id_producto para validación)
      formData.append('id_pagoc', id); // Usar el ID de la URL      
      formData.append('descripcion', datos.Descripcion || '');      
      formData.append('estado', datos.Estado || 'ACTIVO');      
      formData.append('id_sucursal', parseInt(datos.Id_sucursal) || 0);      
      // ✅ MANEJAR LA IMAGEN CORRECTAMENTE - SOLO imagenFile
      if (datos.Imagen && datos.Imagen.length > 0) {
        console.log('🖼️ Actualizando con imagen - tamaño base64:', datos.Imagen.length);
        
        try {
          // Convertir base64 a Blob
          const base64Data = datos.Imagen.replace(/^data:image\/[^;]+;base64,/, '');
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });
          
          // ✅ ENVIAR SOLO COMO imagenFile - NO enviar campo 'imagen'
          formData.append('imagenFile', blob, 'PagoCLiente.jpg');
          console.log('✅ Imagen agregada al FormData SOLO como imagenFile');
          
        } catch (imageError) {
          console.error('❌ Error procesando imagen para actualización:', imageError);
          throw new Error('Error al procesar la imagen para actualización');
        }
      } else {
        console.log('📝 Actualizando sin imagen nueva');
      }
      
      // Debug del FormData final
      console.log('🔍 === FormData FINAL para UPDATE ===');
      for (let pair of formData.entries()) {
        const value = pair[1] instanceof Blob ? `[BLOB: ${pair[1].size} bytes]` : pair[1];
        console.log(`  ${pair[0]}: ${value}`);
      }
      console.log('🔍 URL final:', `${API_CONFIG.ENDPOINTS.PAGOCLIENTE}/${id}`);
      
      const response = await apiClient.put(
        `${API_CONFIG.ENDPOINTS.PAGOCLIENTE}/${id}`, 
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      
      console.log('✅ PagoCLiente actualizado exitosamente:', response.data);
      const updatedData = response.data.data || response.data;
      return new PagoCliente(updatedData);
      
    } catch (error) {
      console.error('❌ === ERROR ACTUALIZANDO PagoCLiente ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response data:', error.response?.data);
      console.error('❌ Error status:', error.response?.status);
      throw new Error('Error al actualizar el PagoCLiente: ' + (error.response?.data?.message || error.message));
    }
  }

  

  // MÉTODO DE PRUEBA
  static async testConnection() {
    try {
      console.log('🧪 === TEST CONNECTION ===');
      console.log('🧪 URL Base:', API_CONFIG.BASE_URL);
      console.log('🧪 Endpoint:', API_CONFIG.ENDPOINTS.PAGOCLIENTE);
      console.log('🧪 URL Completa:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.PAGOCLIENTE);
      
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.PAGOCLIENTE);
      console.log('✅ ¡CONEXIÓN EXITOSA!');
      console.log('✅ Response completo:', response);
      console.log('✅ Response data:', response.data);
      
      return response;
    } catch (error) {
      console.error('❌ FALLO EN LA CONEXIÓN:', error);
      console.error('❌ Error response:', error.response);
      return error;
    }
  }
}